import React from 'react';
import { createRoot } from 'react-dom/client';
import './sharedApi';

require('../src_dll');

const { App } = require('./App');

import(/* webpackChunkName: "legacy" */ /* webpackPreload: true */ './legacy').then(({ loadLegacy }) => {
    return loadLegacy().then(() => {
        const root = createRoot(document.getElementById('react-shell-app')!);
        root.render(<App />);
    });
});
